import {Directive, HostListener} from '@angular/core';
import {NavigationStateService} from './navigation-state.service';

@Directive({
    selector: '[appCloseMenuOnClick]',
    standalone: false
})
export class CloseMenuOnClickDirective {
  constructor(private navState: NavigationStateService) {}

  @HostListener('click') onClick() {
    this.navState.closeMobile();
  }
}
